import {onFind} from "@elements/init-modules-in-scope";
import './scripts/common-shop';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:


import Collapse from 'bootstrap/js/dist/collapse';
onFind('[data-bs-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]',function (element) {
    new Popover(element);
});

import * as lazyIframe from '@elements/lazy-iframe';
lazyIframe.init();

import * as ajaxModal from './scripts/ajax-modal';
ajaxModal.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();

import * as passwordStrength from './scripts/password-strength';
passwordStrength.init();

import * as passwordRepeat from './scripts/password-repeat';
passwordRepeat.init();

import * as fileInput from './scripts/file-input';
fileInput.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as fancySelect from './scripts/fancy-select';
fancySelect.init();

import * as editFormBox from './scripts/edit-form-box';
editFormBox.init();

import * as changeInputsBox from './scripts/change-inputs-box';
changeInputsBox.init();

import * as paymentForm from './scripts/payment-form';
paymentForm.init();